export const PARTY_SUCCESS = "PARTY_SUCCESS";
